module.exports = __webpack_public_path__ + "static/media/0326_IMG_LES_MURS_METRO_DIAMANTO_MAT_TORBA_CHEVRON.11f93735.webp";